import Reveal from "./Reveal";

/* Why Abhyas / Built on Trust — editorial principles, not generic feature cards. */

const PRINCIPLES = [
  {
    n: "01",
    title: "Built for CBSE & ICSE",
    description:
      "Strictly mapped to Class 9–12 curriculum standards and the way board exams actually ask questions.",
    badge: "Syllabus Aligned",
  },
  {
    n: "02",
    title: "Curriculum-matched practice",
    description:
      "Every question is generated for your exact board, class, chapter and difficulty — never a generic question bank.",
    badge: "Precision",
  },
  {
    n: "03",
    title: "Step-by-step solutions",
    description:
      "Clear, step-wise derivations and conceptual explanations for every question — so you learn the method, not just the answer.",
    badge: "Clarity",
  },
  {
    n: "04",
    title: "Structured preparation",
    description:
      "A connected loop of daily practice, instant evaluation and weak-area revision — preparation with a system, not guesswork.",
    badge: "Systematic",
  },
];

const TrustSection = () => (
  <section
    id="why"
    data-testid="why-abhyas-section"
    className="border-y border-[#14532D]/8 bg-white px-4 py-20 sm:px-8 md:py-28 lg:px-12"
  >
    <div className="mx-auto max-w-6xl">
      <div className="max-w-2xl">
        <p className="mb-3">
          <span className="inline-flex items-center gap-2 rounded-lg border border-[#16A34A]/15 bg-[#16A34A]/8 px-3.5 py-1.5 text-[13px] font-bold uppercase tracking-[0.08em] text-[#14532D] sm:text-[14px] lg:text-[15px]">
            <span className="pulse-dot inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-[#16A34A]" />
            Why Abhyas
          </span>
        </p>
        <h2
          data-testid="why-abhyas-headline"
          className="font-display text-[36px] font-bold leading-[1.15] tracking-tight text-[#17201A] sm:text-[48px] lg:text-[56px]"
        >
          Built on trust, calibrated for{" "}
          <span className="text-[#16A34A]">your syllabus.</span>
        </h2>
        <p className="mt-4 font-body text-[17px] leading-[1.6] text-[#647067] sm:text-[19px] lg:text-[20px]">
          No gimmicks, no noise — four principles guide everything Abhyas makes
          for students.
        </p>
      </div>

      <div className="mt-14 grid gap-x-10 gap-y-12 lg:grid-cols-12">
        {PRINCIPLES.map((p, i) => (
          <Reveal
            key={p.n}
            delay={i * 0.08}
            className={
              i % 2 === 0 ? "lg:col-span-7" : "lg:col-span-5 lg:pt-14"
            }
          >
            <div
              data-testid="trust-principle-card"
              className={`border-t-2 pt-6 ${
                i % 2 === 0 ? "border-[#16A34A]" : "border-[#FACC15]"
              }`}
            >
              <div className="flex items-baseline justify-between gap-4">
                <span className="font-display text-sm font-extrabold tracking-[0.14em] text-[#94A39B]">
                  {p.n}
                </span>
                <span className="rounded-full border border-[#FACC15]/40 bg-[#FEF9C3] px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-[#14532D]">
                  {p.badge}
                </span>
              </div>
              <h3 className="mt-3 font-display text-[20px] font-bold tracking-tight text-[#17201A] sm:text-[22px]">
                {p.title}
              </h3>
              <p className="mt-2.5 max-w-lg text-base leading-relaxed text-[#647067]">
                {p.description}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default TrustSection;
